import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "overlay", "searchResults"]

  connect() {
    this.isOpen = false
    this.trigger = document.querySelector("[data-hamburger-trigger='true']")
    this.searchTimeout = null
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.element.classList.add("hamburger-open")
    })
    this.isOpen = true
    this._setTriggerState(true)
    document.body.style.overflow = "hidden"
  }

  close() {
    this.element.classList.remove("hamburger-open")
    this.isOpen = false
    this._setTriggerState(false)
    document.body.style.overflow = ""
    setTimeout(() => {
      this.element.classList.add("hidden")
    }, 260)
  }

  closeOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  onSearchInput(event) {
    const query = event.target.value.trim()
    clearTimeout(this.searchTimeout)

    if (!this.hasSearchResultsTarget) return

    if (query.length < 2) {
      this.searchResultsTarget.classList.add("hidden")
      this.searchResultsTarget.innerHTML = ""
      return
    }

    this.searchTimeout = setTimeout(() => this.fetchResults(query), 200)
  }

  async fetchResults(query) {
    try {
      const res = await fetch(`/search/suggestions?q=${encodeURIComponent(query)}`)
      const data = await res.json()
      const el = this.searchResultsTarget

      if (data.results && data.results.length > 0) {
        el.innerHTML = data.results.slice(0, 8).map(r => `
          <a href="${r.url}">
            ${r.image
              ? `<img src="${r.image}" class="org-logo org-logo--tiny" style="max-height:1.5rem;max-width:5rem;width:auto;height:auto;object-fit:contain;flex-shrink:0;">`
              : `<div class="sr-icon"><i class="${r.icon}"></i></div>`
            }
            <div style="flex:1;min-width:0;">
              <div class="sr-title">${this.esc(r.title)}</div>
              <div class="sr-sub">${this.esc(r.subtitle || '')}</div>
            </div>
          </a>
        `).join("") + `<a href="/search?q=${encodeURIComponent(query)}" class="sr-all">View all results →</a>`
      } else {
        el.innerHTML = `<div class="sr-empty">No results for "${this.esc(query)}"</div>`
      }
      el.classList.remove("hidden")
    } catch(e) { console.error("Search:", e) }
  }

  esc(t) { const d = document.createElement("div"); d.textContent = t; return d.innerHTML }

  _setTriggerState(open) {
    if (!this.trigger) return
    this.trigger.setAttribute("aria-expanded", open ? "true" : "false")
  }
}
